module.exports = __webpack_public_path__ + "img/fonticons-fi.f29104c7.svg";